import {TButtonProps} from "@/app/[locale]/common/components/Button/types";
import s from './Button.module.scss';

export const Button = ({ size, children, type = 'button', className, disabled = false, onClick }: TButtonProps) => {
    return (
        <button
            type={type}
            disabled={disabled}
            className={`${s.button} ${s[size]} ${className ? className : ''}`}
            onClick={onClick}
        >
            { children }
        </button>
    );
};